/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_6Inputs */

const en_us2_onboarding_parq_6 = /** @type {(inputs: Onboarding_Parq_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is your doctor currently prescribing medication for blood pressure or a heart condition?`)
};

const pt_br2_onboarding_parq_6 = /** @type {(inputs: Onboarding_Parq_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu médico está receitando algum medicamento para pressão arterial ou para o coração?`)
};

const es_419_onboarding_parq_6 = /** @type {(inputs: Onboarding_Parq_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tu médico te receta actualmente algún medicamento para la presión arterial o para el corazón?`)
};

const pt_pt2_onboarding_parq_6 = /** @type {(inputs: Onboarding_Parq_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu médico está a receitar-te algum medicamento para a tensão arterial ou para o coração?`)
};

const fr_fr2_onboarding_parq_6 = /** @type {(inputs: Onboarding_Parq_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton médecin te prescrit-il actuellement des médicaments pour la tension artérielle ou un problème cardiaque ?`)
};

const de_de2_onboarding_parq_6 = /** @type {(inputs: Onboarding_Parq_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschreibt dir dein Arzt derzeit Medikamente gegen Bluthochdruck oder eine Herzerkrankung?`)
};

const it_it2_onboarding_parq_6 = /** @type {(inputs: Onboarding_Parq_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo medico ti sta prescrivendo farmaci per la pressione o per il cuore?`)
};

/**
* | output |
* | --- |
* | "Is your doctor currently prescribing medication for blood pressure or a heart condition?" |
*
* @param {Onboarding_Parq_6Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_6 = /** @type {((inputs?: Onboarding_Parq_6Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_6Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_6(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_6(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_6(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_6(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_6(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_6(inputs)
	return en_us2_onboarding_parq_6(inputs)
});
export { onboarding_parq_6 as "onboarding.parq.6" }